module.exports = __webpack_public_path__ + "img/california.9a5854a8.png";